import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export const ParallaxHero = ({ 
  imageSrc, 
  imageAlt, 
  children, 
  className = '',
  overlayClassName = '',
  parallaxIntensity = 0.3,
  priority = false
}) => {
  const ref = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ['0%', `${parallaxIntensity * 100}%`]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.1]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0.3]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.div 
        className="absolute inset-0"
        style={{ y, scale }}
      >
        <motion.img 
          src={imageSrc}
          alt={imageAlt}
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          className="w-full h-full object-cover"
          style={{ opacity }}
        />
      </motion.div>
      
      {/* Overlay */}
      <div className={`absolute inset-0 ${overlayClassName}`} />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
